import { FULL_MONTH_NAME_REGEX } from './date_matching.js';

// denson_song_references

// This module exports these global variables, useful for tools that
// need to parse minutes:

// guess_denson(name, location, year, body) -- heuristically guess whether a singing is probably Denson
// analyze_denson_song_references(body)
// denson_candidate_songnum_markup(songnum) -- determine correct markup for a possible denson song match

// DensonTuneList: list of all valid tune numbers in the Denson book, in order.

// DensonTuneList:

// Note: pp. 24t, 24b, and 25 contain illustrative exercises, not
// editorial song content, but some people do call them at conventions
// so they are listed here.  The "real" first page is 26.

export const DensonTuneList = `
24t 24b 25 26 27 28t 28b 29t 29b 30t 30b 31t
31b 32t 32b 33t 33b 34t 34b 35 36t 36b 37t
37b 38t 38b 39t 39b 40 41 42 43 44 45t 45b
46 47t 47b 48t 48b 49t 49b 50t 50b 51 52t
52b 53 54 55 56t 56b 57 58 59 60 61 62 63 64
65 66 67 68t 68b 69t 69b 70t 70b 71 72t 72b
73t 73b 74t 74b 75 76t 76b 77t 77b 78 79 80t
80b 81t 81b 82t 82b 83t 83b 84 85 86 87 88t
88b 89 90 91 92 93 94 95 96 97 98 99 100
101t 101b 102 103 104 105 106 107 108t 108b
109 110 111t 111b 112 113 114 115 116 117
118 119 120 121 122 123t 123b 124 125 126
127 128 129 130 131t 131b 132 133 134 135
136 137 138t 138b 139 140 141 142 143 144
145t 145b 146 147t 147b 148 149 150 151 152
153 154 155 156 157 158 159 160t 160b 161
162 163t 163b 164 165 166 167 168 169 170
171 172 173 174 175 176t 176b 177 178 179
180 181 182 183 184 185 186 187 188 189 191
192 193 195 196 197 198 200 201 202 203 204
205 206 207 208 209 210 211 212 213t 213b
214 215 216 217 218 220 222 223 224 225t
225b 227 228 229 230 231 232 234 235 236 240
242 245 250 254 260 263 266 267 268 269 270
271t 271b 272 273 274t 274b 275t 275b 276
277 278t 278b 279 280 282 283 284 285t 285b
286 287 288 289 290 291 292 293 294 295 296
297 298 299 300 301 302 303 304 306 308 309
310 311 312t 312b 313t 313b 314 315 316 317
318 319 320 321 322 323t 323b 324 325 326
327 328 329 330t 330b 331 332 333 334 335
336 337 338 339 340 341 342 343 344 345b
345t 346 347 348t 348b 349 350 351 352 353
354t 354b 355 358 359 360 361 362 365 367
368 369 370 371 372 373 374 375 376 377 378t
378b 379 380 381 382 383 384 385t 385b 386
387 388 389 390 391 392 393 394 395 396 397
398 399t 399b 400 401 402 403 404 405 406
407 408 409 410t 410b 411 412 413 414 415
416 417 418 419 420 421 422 423 424 425 426t
426b 428 429 430 431 432 433 434 435 436 437
438 439 440 441 442 444 445 446 447 448t
448b 449 450 451 452 453 454 455 456 457 458
459 460 461 462 463 464 465 466 467 468 470
471 472 473 474 475 476 477 478 479 480 481
482 483 484 485 486 487 488 489 490 491 492
493 494 495 496 497 498 499 500 501 502 503
504 505 506 507 510 511 512 513 515 516 517
518 521 522 523 524 527 528 530 531 532 534
535 536 538 539 540 541 542 543 544 545 546
547 548 549 550 551 553 556 558 560 562 564
565 566 567 568 569t 569b 570 571 572 573
`.match(/\w+/g);

export const DensonCorrectors = (() => {
  let c = {};
  DensonTuneList.forEach(songnum => {
    let [all, num, tb] = songnum.match(/^(\d+)([tb]?)$/); // eslint-disable-line no-unused-vars
    // known-good markers -- all songnums in DensonTuneList are known-good
    c[songnum] = `[${songnum}]`; // Known-good marker: [40] or [569t] or [569b]

    // ambiguity markers
    if (tb === 't') {
      // has top/bottom versions.  without "t" or "b" it is ambiguous.
      c[num] = `{${num}}`; // Ambiguity marker: 569 => {569}
    }

    // correction markers
    if (tb === '') {
      // has no top/bottom versions; any "t" or "b" can be corrected.
      c[`${num}t`] = `[${num}t/${songnum}]`; // Correction marker: 570t => [570t/570]
      c[`${num}b`] = `[${num}b/${songnum}]`; // Correction marker: 570b => [570b/570]
    }
  });
  return c;
})();

//

export function denson_candidate_songnum_markup(songnum) {
  return DensonCorrectors[songnum] || `<${songnum}>`; // Known-bad marker: 255 => <255?
}

// guess_denson:

// Heuristic function to identify Denson singings: if a singing
// mentions Cooper Book or Cooper Revision or B.F. White or J.L.
// White or Electic Harmony, etc. in the name, assume it is not
// a Denson singing.  We also omit most mixed singings
// (unless they use the proper notation (CB), etc. to mark
// non-Denson songs).  Only the singings that qualify as
// "IsDenson" will be hyperlinked or counted for statistical
// purposes.  We will let the editor override the designation.

export function guess_denson(name, location, year, body) {
  // Need the basic info even to guess
  if (!(name.length > 0)) return null;
  if (!(location.length > 0)) return null;
  if (!(year > 1900)) return null;

  // Look for song number annotations.  If more than 5, we guess this is a mixed singing with annotations.
  if (
    body &&
    body.length > 0 &&
    (body.match(/(?:\d{2,3}[TBtb]?\b)(?!\w) \(\w{1,4}(?: \d+)?\)/g) || [])
      .length > 5
  )
    return 'mixed';

  // Known-Cooper singings not always marked as such
  if (name.match(/(Cooper)/i)) return 'non-denson';
  if (name.match(/((J\.L\.)|(B\.F\.) White)|(Eclectic Harmony)/i))
    return 'non-denson';
  if (
    name.match(
      /(East Texas)|(Southeast Texas)|(Southwest Texas)|(Brazos River)|(Zion Hill Homecoming)/i
    )
  )
    return 'non-denson';
  if (name.match(/(Florida State)|(Baldwin County)/i)) return 'non-denson';
  if (name.match(/(Tennessee State)/i)) return 'non-denson';

  // Shenandoah Harmony Singings
  if (name.match(/(Shenandoah Harmony)/i)) return 'non-denson';

  // Other misc. singings...
  if (name.match(/(Georgian Harmony)/i)) return 'non-denson';
  if (name.match(/(Christian Harmony)/i)) return 'non-denson';
  if (name.match(/(Missouri Harmony)/i)) return 'non-denson';
  if (name.match(/(B.? F.? White)/i)) return 'non-denson';
  if (name.match(/(J.? L.? White)/i)) return 'non-denson';
  if (name.match(/(White Book)/i)) return 'non-denson';
  if (name.match(/(Christmas Harp)/i)) return 'non-denson';
  if (name.match(/(New Harp of Columbia)/i)) return 'non-denson';
  if (name.match(/(American Vocalist)/i)) return 'non-denson';

  // Southern Harmony singings
  if (name.match(/(Big Singing)/i)) return 'non-denson';

  // Mixed-book singings
  if (name.match(/(Rotunda Singing)/i)) return 'non-denson';
  if (name.match(/(Fohs Hall)/i)) return 'non-denson';
  if (name.match(/(William Walker Memorial)/i)) return 'non-denson';
  if (name.match(/(University of Georgia)/i)) return 'non-denson';
  if (name.match(/(Velton Chafin Birthday)/i)) return 'non-denson';
  if (name.match(/(Harrods Creek)/i)) return 'non-denson';
  if (location.match(/(Harrods Creek)/i)) return 'non-denson';

  let yearnum = Number.parseInt(year, 10);

  // Singings that became mixed as of a certain date; assume perpetually so
  if (name.match(/(Joe Beasley Memorial Singing)/i) && yearnum >= 2004)
    return 'non-denson';

  // Mixed-book singings that are properly annotated in years except these:
  if (name.match(/(Connecticut Convention)/i) && yearnum === 1995)
    return 'non-denson';
  if (name.match(/(Missouri State)/i) && year.match(/(199[56])/))
    return 'non-denson';
  if (name.match(/(Furman University)/i) && year.match(/(200[45])/))
    return 'non-denson';
  if (name.match(/(Pacific Northwest)/i) && year.match(/(1998)|(200[02])/))
    return 'non-denson';
  if (
    name.match(/(New York State Sacred Harp Convention)/i) &&
    yearnum === 2001
  )
    return 'non-denson';

  // Non-singings
  if (location.match(/Annual Meeting/)) return 'non-denson';

  return 'denson';
}

// analyze_denson_song_references(body) -- look for, annotate (via special markups),
// and gather stats on, apparent references to denson songs.

// Break body into these kinds of tokens -- note: order is important!
export const name_word_chars = 'A-zÀ-úĀ-ſ';
export const tokenREs = {
  // Note: can't use lookaheads in these!
  w_space: '(?:\\s+)', // Runs of any kind of whitespace
  dollars: '(?:\\$\\d[\\d,.]+\\d)', // dollar amounts e.g. $1,245.00
  time_vl: '(?:\\d+:\\d+)', // time amounts e.g. 10:00
  // A 'forced' markup indicator saying the song should be counted even if the parser
  // would not have otherwise identified it, e.g. John taught [45t] to open the singing.
  forcenm: '\\[(?:\\d{2,3}[tbTB]?\\b)\\]',
  // numbers which could also be possible song numbers
  // (2-3 digits maybe followed by t or b),
  // then optional " (CB)", then trailing ", " or "; ", or "." or " (" (latter case example: "34t (...for Bob Smith)"
  led_ind:
    '(?:(?:\\b(?:lea?d|[sS]ongs:|on|[pP]ages?)?) (?:\\d{2,3}[tbTB]?\\b)(?: \\([a-zA-Z]+(?: \\d)?\\))?(?:(?:[,;] )|(?:\\.)|(?: \\()|(?: )))',
  songind:
    '(?:(?:\\d{2,3}[tbTB]?\\b)(?: \\([a-zA-Z]+(?: \\d)?\\))?(?:(?:[,;] )|(?:\\.)|(?: \\())?)',
  integer: '(?:\\d+(?:,\\d{3})*)', // other integers which could include comma-separated segments
  dashrow: '(?:--{3,})', // Runs of 3 or more dashes
  em_dash: '(?:--)', // long dashes (--) as runs of 2 dashes
  eq_head: '(?:==)', // double-equal sign markups
  punctmk: '(?:[()/\'"“”‘’•*$:;.,!?-])', // // other single punctuation marks
  // words / names that start with latin letters and can contain any number of quotes, dashes, and further latin letters. // Allow trailing colon
  name_wd: `(?:[${name_word_chars}]+(?:['’-][${name_word_chars}]+)*:?)`,
  non_spc: '(?:\\S+?)' // Any other runs of non-whitespace, non-greedily
};

export const tokenREsOrder = [
  // Keep order same as above!  Order matters.
  'w_space',
  'dollars',
  'time_vl',
  'forcenm',
  'led_ind',
  'songind',
  'integer',
  'dashrow',
  'em_dash',
  'eq_head',
  'punctmk',
  'name_wd',
  'non_spc'
];

export const tokenREsList = tokenREsOrder.map(name => {
  return tokenREs[name];
});

export const tokenizer = RegExp('(' + tokenREsList.join('|') + ')', 'gu');

const forcenmRE = new RegExp('^(?:' + tokenREs.forcenm + ')$'); // Matches the "forced" form only.
const forcenm_or_led_indRE = new RegExp( // Matches the "forced", or "led" form.
  '^(?:' + tokenREs.forcenm + '|' + tokenREs.led_ind + ')$'
);
const songindRE = new RegExp( // Matches the "forced", "led" or regular form
  '^(?:' +
    tokenREs.forcenm +
    '|' +
    tokenREs.led_ind +
    '|' +
    tokenREs.songind +
    ')$'
);
const songnumRE = new RegExp('\\[?(\\d{2,3}[tbTB]?\\b)\\]?'); // used to pull from a token that already matched forced, led, or song_ind
const rightParenRE = new RegExp('\\)');
const correctedRE = new RegExp('\\/');
const goodRE = new RegExp('\\[');
const ambiguousRE = new RegExp('\\{');
const badRE = new RegExp('<');
const name_wdRE = new RegExp('^' + tokenREs.name_wd + '$');

export function analyze_denson_song_references(body) {
  let good = [];
  let corrected = [];
  let ambiguous = [];
  let bad = [];
  let tokens = body.match(tokenizer) || []; // [] should only happen with body = empty string.

  let marked_up = tokens.map((t, i) => {
    // console.log(t);
    // pass through tokens that are not song num indicators
    if (!t.match(songindRE)) {
      return t;
    }
    // ignore song numbers with non-denson indicators e.g. (CB) -- identified by closing )
    if (t.match(rightParenRE)) {
      return t;
    }

    // If the match is just an integer, it shouldn't be followed by word chars. e.g. 98/th
    if (t.match(/\d+$/) && tokens[i + 1] && tokens[i + 1].match(/^\w+/)) {
      return t;
    }

    // console.log([tokens[i-3],tokens[i-2],tokens[i-1],tokens[i]].join("/"));

    // In addition to matching the general song number indicator patterns,
    // to be accepted as a likely match, one of these further things must be true:
    // 1) matches the "forced" or "led" form of the song match pattern, or   // e.g "[34t]" or "led 34t"
    // 2) The prior token must be another song match, or		// e.g. "108t, " + "34t; "
    // 3) (must be a space AND the one prior token to that must look like a name), or // e.g. "Smith" + " " + "34t,"
    // 4) (must be a space AND the 3rd prior token to that must look like a forced match) // e.g. "[202]" + "," + " " + "34t,"
    if (
      !(
        t.match(forcenm_or_led_indRE) ||
        (tokens[i - 1] && tokens[i - 1].match(songindRE)) ||
        (tokens[i - 1] &&
          tokens[i - 1] === ' ' &&
          tokens[i - 2] &&
          tokens[i - 2].match(name_wdRE)) ||
        (tokens[i - 1] &&
          tokens[i - 1] === ' ' &&
          tokens[i - 3] &&
          tokens[i - 3].match(forcenmRE))
      )
    ) {
      return t;
    }

    // If the word prior to this possible match is the name of a month, assume it's really meant to be a date.
    if (
      tokens[i - 1] === ' ' &&
      tokens[i - 2] &&
      tokens[i - 2].match(FULL_MONTH_NAME_REGEX)
    ) {
      let num = parseInt(t.match(/\d+/)[0], 10);
      if (num && num >= 10 && num <= 31) {
        return t;
      }
    }

    // Now we think it might be a denson song.  Determine the best markup for it.
    // Note, this could change a forced markup e.g. [45] to an error, correction, bad, etc.
    let with_markup = t.replace(songnumRE, (ignore, songnum) => {
      let markup = denson_candidate_songnum_markup(songnum);
      // Count this result towards 1 of our 4 stats...

      switch (true) {
        case !!markup.match(correctedRE):
          corrected.push(songnum);
          break;
        case !!markup.match(goodRE):
          good.push(songnum);
          break;
        case !!markup.match(ambiguousRE):
          ambiguous.push(songnum);
          break;
        case !!markup.match(badRE):
          bad.push(songnum);
          break;
        default:
          break; // should not happen
      }
      return markup;
    });
    return with_markup;
  });
  let body_with_markups = marked_up.join('');
  return {
    body_with_markups: body_with_markups,
    song_markups_known_good: good,
    song_markups_corrected: corrected,
    song_markups_ambiguous: ambiguous,
    song_markups_bad: bad
  };
}



// WEBPACK FOOTER //
// ./src/denson_song_references.js